import React from 'react';
import './index.scss';
import _ from 'lodash';
import SearchBar from '../SearchBar/index.jsx';
import { useTranslation } from 'react-i18next';
import HomeDeliveryWorks from '../HomeDeliveryNew/HomeDeliveryWorks';
import HomeDeliveryFaq from '../HomeDeliveryNew/HomeDeliveryFaq';
import { Helmet } from 'react-helmet';
import {
  HOME_CANONICAL,
  PRESC_DEL_DESC,
  PRESC_DEL_DESC_ES,
  PRESC_DEL_TITLE,
  PRESC_DEL_TITLE_ES
} from '../../constants/defaults';
import SkipTo from '../common/Tag/SkipTo';
import NotFound from '../NotFound/index.jsx';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);

const HomeDeliveryNew = props => {
  const { t, i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');
  if (!API.ALLOW_HOME_DELIVERY) return <NotFound />;
  return (
    <main>
      <div className="homeDeliveryContainer">
        <Helmet>
          <title>{isEs ? PRESC_DEL_TITLE_ES : PRESC_DEL_TITLE}</title>
          {isEs ? (
            <meta name="description" content={PRESC_DEL_DESC_ES} />
          ) : (
            <meta name="description" content={PRESC_DEL_DESC} />
          )}
          <meta property="og:title" content={PRESC_DEL_TITLE} />
          <meta property="og:description" content={PRESC_DEL_DESC} />
          <meta
            property="og:image"
            content={`${HOME_CANONICAL}/content/images/homepage/singleCareLogo.jpg`}
          />
          <meta
            property="og:url"
            content={`https://www.singlecare.com${props.location.pathname}`}
          />
          <meta property="og:site_name" content="SingleCare" />
          <meta property="og:type" content="website" />
          <link
            rel="canonical"
            href={`https://www.singlecare.com${props.location.pathname}`}
          />
          <link
            rel="alternate"
            href={`${HOME_CANONICAL}/prescription-delivery`}
            hrefLang="en-us"
          />
          <link
            rel="alternate"
            href="https://www.singlecare.com/es/medicamentos-a-domicilio"
            hrefLang="es-us"
          />
        </Helmet>
        <div className="topShadow"></div>
        <section className="homeDeliveryBanner">
          <SkipTo>
            <h1 className="textCenter">{t('Save on home delivery')}</h1>
          </SkipTo>
          <h2 className="textCenter desktop-only">
            {t('Get prescriptions delivered to your door with SingleCare +')}
            <br />
            {t('GeniusRx. A valid prescription is required')}
          </h2>
          <h2 className="textCenter mobile-only">
            {t('Get prescriptions delivered to your door')} <br />
            {t('with SingleCare + GeniusRx')}.
          </h2>
          <div id="desktTopSearchbar">
            <SearchBar
              classes="search-container"
              handleZipCodeChange={() => null}
              history={props.history}
              showZipCode={false}
            />
          </div>
          <p className="mobile-only textCenter">
            <span>{t('A valid prescription is required')}.</span>
          </p>
        </section>
        <section className="homeDeliverySteps">
          <div className="stepsContainer textCenter">
            <div className="steps">
              <h3>{t('Free Shipping')}</h3>
              <p>
                {t('Shipping is always included in the')} <br />
                {t('listed price')}.
              </p>
              <span className="line mobile-only"></span>
            </div>
            <div className="steps">
              <h3>{t('4,000 eligible drugs')}</h3>
              <p>
                {t('Home delivery is available for our')} <br />
                {t('most-prescribed drugs')}.
              </p>
              <span className="line mobile-only"></span>
            </div>
            <div className="steps">
              <h3>{t('Easy script transfers')}</h3>
              <p>
                {t('Our partner, GeniusRx makes')} <br />
                {t('transferring prescriptions a')}
                <br className="desktop-only" /> {t('breeze')}.
              </p>
            </div>
          </div>
        </section>

        <HomeDeliveryWorks />
        <HomeDeliveryFaq />
      </div>
    </main>
  );
};

export default HomeDeliveryNew;
